import uuid4 from 'uuid4';

import { DOM, isServer } from '@app/utils';

/**
 * This is mostly here for fraud. It will only work on the browser!
 */
const getOrSetStockXFraudSessionId = () => {
  if (isServer) {
    return undefined;
  }

  let sessionId = DOM.getCookie<string | undefined>('stockx_session');
  if (sessionId) {
    return sessionId;
  }

  sessionId = uuid4();

  //
  // Set as cookie
  DOM.setCookie('stockx_session', sessionId, {
    path: '/',
    maxAge: 3600,
  });

  //
  // set as riskified
  if (window?.RISKX) {
    window.RISKX.setSid(sessionId);
  }

  return sessionId;
};

export default getOrSetStockXFraudSessionId;
